export const recFormatDictionary = {
  'raw': 'RAW (CFast)',
  'mp4': 'MP4 (SD Card)',
  'xf': 'XF-AVC (SD Card)'
};

export const recFormatDictionaryReverse = {
  'RAW (CFast)': 'raw',
  'MP4 (SD Card)': 'mp4',
  'XF-AVC (SD Card)': 'xf',
};
